import * as Appendix from "./Appendix/index.js";
import * as MarketReports from "./MarketReports/index.js";
import * as Common from "./Common/index.js";
import * as LeasingPeers from "./LeasingPeers/index.js";
import * as ConstructionProperties from "./ConstructionProperties/index.js";
import * as SubjectProperty from "./SubjectProperty/index.js";
import * as Commercial from "./Commercial/index.js";
import * as CustomMarketReport from "./CustomMarketReport/index.js";
import * as Demographics from "./Demographics/index.js";
import * as StudentRentSurveyReport from "./StudentRentSurveyReport/index.js";
import * as SaleComparable from "./SaleComparable/index.js";
import * as IndependentOwnerReport from "./IndependentOwnerReport/index.js";
import * as RentTrends from "./RentTrends/index.js";
import * as LeaseComp from "./LeaseComp/index.js";
import * as LeasingAnalytics from "./LeasingAnalytics/index.js";
import * as MarketShare from "./MarketShare/index.js";
import * as PropertyReports from "./PropertyReports/index.js";
import * as RentComparable from "./RentComparable/index.js";
import * as Sanitize from "./Sanitize/index.js";
import * as Underwriting from "./Underwriting/index.js";
import * as UniversityReport from "./UniversityReport/index.js";
/** CoStar.Api.AnalyticReports.ComprehensiveBuildingReportSection */
export var ComprehensiveBuildingReportSection;
(function (ComprehensiveBuildingReportSection) {
    ComprehensiveBuildingReportSection[ComprehensiveBuildingReportSection["CoverPage"] = 0] = "CoverPage";
    ComprehensiveBuildingReportSection[ComprehensiveBuildingReportSection["SubjectProperty"] = 1] = "SubjectProperty";
    ComprehensiveBuildingReportSection[ComprehensiveBuildingReportSection["CompetitorSummary"] = 2] = "CompetitorSummary";
})(ComprehensiveBuildingReportSection || (ComprehensiveBuildingReportSection = {}));
/** CoStar.Api.AnalyticReports.SearchCriteriaType */
export var SearchCriteriaType;
(function (SearchCriteriaType) {
    SearchCriteriaType[SearchCriteriaType["Default"] = 0] = "Default";
    SearchCriteriaType[SearchCriteriaType["CurrentSurvey"] = 1] = "CurrentSurvey";
    SearchCriteriaType[SearchCriteriaType["SavedSurvey"] = 2] = "SavedSurvey";
})(SearchCriteriaType || (SearchCriteriaType = {}));
/** CoStar.Api.AnalyticReports.ReportTheme */
export var ReportTheme;
(function (ReportTheme) {
    ReportTheme[ReportTheme["Default"] = 0] = "Default";
    ReportTheme[ReportTheme["Apartments"] = 1] = "Apartments";
    ReportTheme[ReportTheme["CoStar"] = 2] = "CoStar";
    ReportTheme[ReportTheme["MarketAnalytics"] = 3] = "MarketAnalytics";
})(ReportTheme || (ReportTheme = {}));
export { Appendix, MarketReports, Common, LeasingPeers, ConstructionProperties, SubjectProperty, Commercial, CustomMarketReport, Demographics, StudentRentSurveyReport, SaleComparable, IndependentOwnerReport, RentTrends, LeaseComp, LeasingAnalytics, MarketShare, PropertyReports, RentComparable, Sanitize, Underwriting, UniversityReport };
